import React from 'react';
import { FuelTypography, FuelSign } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { widthMap } from '@components/ui/Modal/ModalStyles';
import { useNavigate } from 'react-router-dom';
import { ContentPropsInterface } from './ContentTypes';
import Header from './Header';
import Actions from './Actions';
import Disclaimer from './Disclaimer';

function Content({
  actions,
  description,
  freightIdEncoded,
  icon,
  isShow,
  title,
  truckerIdEncoded,
  proposalId,
  isReject,
  slug,
  onClose,
}: ContentPropsInterface) {
  const navigate = useNavigate();
  function handleRejected() {
    if (slug === 'insured-with-reproved-gr') {
      let uriGRCreate = '/gestao-de-risco/cadastro';

      if (freightIdEncoded && truckerIdEncoded) {
        uriGRCreate += `?frete=${freightIdEncoded}&motorista=${truckerIdEncoded}`;
      }

      navigate(uriGRCreate);
      return;
    }

    onClose();
  }

  if (!isShow) {
    return null;
  }

  return (
    <FuelFlex
      defaultProps={{
        flexDirection: 'column',
        gap: 'km6',
        maxWidth: widthMap.xs,
        minHeight: '160px',
      }}
    >
      {icon && <FuelSign icon={icon} iconStyle="filled" size="medium" />}
      <Header title={title} />
      <FuelTypography weight="medium">{description}</FuelTypography>
      <Disclaimer slug={slug} />
      <Actions
        onClose={onClose}
        onRejected={() => handleRejected()}
        actions={actions}
        proposalId={proposalId}
        isReject={isReject}
      />
    </FuelFlex>
  );
}

export default Content;
